import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import componentsStyle from 'assets/jss/material-kit-react/views/components.jsx';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import HOCLoader from '../HOC/HOCLoader';
import { withTheme } from '@material-ui/core/styles';
import { Link, Element } from 'react-scroll';
import { FormattedMessage } from 'react-intl';
import AppLinks from '../../components/About/AppLinks';

class SimpleCategoryListing extends React.Component {
    constructor() {
        super();
        this.state = {
            clickedServiceId: null,
            providerData: [],
            detailRedirect: false,
            toggle: false
        };
    }
    componentDidMount() {
        this.getData();
    }
    getData = () => {
        this.props.allCategoryAction();
    };
    redirectLink = serviceId => {
        this.props.serviceProviderListAction(
            {
                serviceId: serviceId,
                type: 2,
                day: new Date().getDay(),
                offset: new Date().getTimezoneOffset()
            },
            this.onDone
        );
        this.setState({ clickedServiceId: serviceId });
    };
    onDone = (success, data) => {
        if (success) {
            this.setState({
                providerData: data.data.providerList,
                redirect: true
            });
        }
    };
    handleToggle = () => {
        this.setState((prevState, props) => ({
            toggle: !prevState
        }));
    };
    render() {
        const { classes, categoryData } = this.props;

        if (this.state.redirect) {
            this.props.history.push({
                pathname: `/provider/list/${this.state.clickedServiceId}`,
                state: {
                    serviceId: this.state.clickedServiceId,
                    providerData: this.state.providerData
                }
            });
        }
        if (this.state.detailRedirect) {
            this.props.history.push({
                pathname: `/provider/list/${this.state.clickedServiceId}`,
                state: {
                    serviceId: this.state.clickedServiceId,
                    providerData: this.state.providerData
                }
            });
        }
        return (
            <HOCLoader loading={this.props.categoryLoader}>
                <div
                    className={classNames(classes.main + ' category-main-lux')}
                >
                    <div className="container">
                        <div className="dir-alp-tit">
                            <h1>All Categories</h1>
                        </div>
                        <div className="dir-alp-con">
                            <GridContainer>
                                <GridItem xs={12} md={3} sm={3}>
                                    <div className="dir-alp-con-left">
                                        <div className="dir-alp-con-left-1">
                                            <h3>
                                                <FormattedMessage
                                                    id="category.title"
                                                    defaultMessage="All Categories"
                                                />{' '}
                                            </h3>
                                        </div>

                                        <div className="dir-alp-l3 dir-alp-l-com">
                                            <div className="dir-alp-l-com1 dir-alp-p3">
                                                <ul>
                                                    {categoryData.map(
                                                        (n, index) => {
                                                            return (
                                                                <li key={index}>
                                                                    <Link
                                                                        activeClass="active"
                                                                        to={
                                                                            'cat-' +
                                                                            index
                                                                        }
                                                                        spy={
                                                                            true
                                                                        }
                                                                        smooth={
                                                                            true
                                                                        }
                                                                        duration={
                                                                            250
                                                                        }
                                                                        containerId="containerElement"
                                                                        style={{
                                                                            cursor:
                                                                                'pointer'
                                                                        }}
                                                                    >
                                                                        <label>
                                                                            {
                                                                                n.heading
                                                                            }
                                                                        </label>
                                                                    </Link>
                                                                </li>
                                                            );
                                                        }
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </GridItem>

                                <GridItem xs={12} md={9} sm={9}>
                                    <div className="service-main-box">
                                        <Element
                                            className="element"
                                            id="containerElement"
                                            style={{
                                                position: 'relative',
                                                height: '600px',
                                                overflow: 'hidden',
                                                overflowY: 'auto',
                                                paddingRight: '30px'
                                            }}
                                        >
                                            {categoryData.map(
                                                (category, index) => {
                                                    return (
                                                        <Element
                                                            key={index}
                                                            name={
                                                                'cat-' + index
                                                            }
                                                            style={{
                                                                marginBottom: 50
                                                            }}
                                                        >
                                                            {category.services &&
                                                                category
                                                                    .services
                                                                    .length >
                                                                    0 && (
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            <h2>
                                                                                {
                                                                                    category.heading
                                                                                }
                                                                            </h2>
                                                                        </div>
                                                                        <div className="col-md-12">
                                                                            <div className="row">
                                                                                {category.services &&
                                                                                    category.services.map(
                                                                                        (
                                                                                            service,
                                                                                            catIndex
                                                                                        ) => {
                                                                                            return (
                                                                                                <div
                                                                                                    className="col-md-4"
                                                                                                    key={
                                                                                                        catIndex
                                                                                                    }
                                                                                                >
                                                                                                    <div
                                                                                                        style={{
                                                                                                            cursor:
                                                                                                                'pointer'
                                                                                                        }}
                                                                                                        className="service-main-collapse"
                                                                                                        onClick={() =>
                                                                                                            this.redirectLink(
                                                                                                                service.slug
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        <div className="list-mig-like-com com-mar-bot-30">
                                                                                                            <div className="list-mig-lc-img">
                                                                                                                {' '}
                                                                                                                <img
                                                                                                                    src={
                                                                                                                        service
                                                                                                                            .image
                                                                                                                            .medium
                                                                                                                    }
                                                                                                                    alt="list"
                                                                                                                />{' '}
                                                                                                            </div>
                                                                                                            <div className="list-mig-lc-con">
                                                                                                                <h5>
                                                                                                                    {
                                                                                                                        service.heading
                                                                                                                    }
                                                                                                                </h5>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            );
                                                                                        }
                                                                                    )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                        </Element>
                                                    );
                                                }
                                            )}{' '}
                                        </Element>
                                    </div>
                                </GridItem>
                            </GridContainer>
                        </div>
                    </div>
                </div>

                <AppLinks settings={this.props.settings} />
            </HOCLoader>
        );
    }
}

const mapStateToProps = ({ categories, settings }) => {
    return {
        categoryData: categories.categoryData,
        categoryLoader: categories.categoryLoader,
        settings: settings
    };
};
const composedComponent = compose(
    withTheme(),
    withStyles(componentsStyle),
    connect(mapStateToProps, actions)
);
export default composedComponent(withRouter(SimpleCategoryListing));



// WEBPACK FOOTER //
// ./src/components/Category/SimpleCategoryListing.js